import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { BsDownload } from "react-icons/bs";
import { Link } from "react-router-dom";
import {
	download_file_content,
	get_generated_file_list,
} from "../../../../api/endpoints/auditory";
import Main from "../../../layout/main/Main";
import { COLORS, Typo } from "../../../layout/theme";
import {
	AntdTable,
	Container,
	FilterContainer,
	ImageSection,
	Inner,
	Section,
	TableContainer,
} from "./styles";
import { get_distributors_name_list } from "../../../../api/endpoints/distributors";
import { get_megaDistributors_name_list } from "../../../../api/endpoints/megaDistributors";
import { CONSTANTS } from "../../../../utils/constants";
import {
	TYPE,
	openNotificationWithIcon,
} from "../../../../utils/notificationToast";
import moment from "moment";

const { Option } = Select;

export default function SendedFiles() {
	const [isLoading, setIsLoading] = useState(false);
	const [distributors, setDistributors] = useState(null);
	const [selectedType, setSelectedType] = useState(null);
	const [selectedDistributor, setSelectedDistributor] = useState(null);
	const [generatedFileList, setGeneratedFileList] = useState(null);
	const [folderState, setFolderState] = useState("enviados");

	const fetch_distributors = async () => {
		const res = await get_distributors_name_list();
		setDistributors(res);
	};

	const fetch_mega_distributors = async () => {
		const res = await get_megaDistributors_name_list();
		setDistributors(res);
	};

	const fetch_generated_file_list = async () => {
		try {
			const distributor = distributors.find(
				(d) => d.id === selectedDistributor,
			);
			const distributorSendType = JSON.parse(distributor.typeOfArchive).send;
			const folderPath = `${selectedType}/${selectedDistributor}/${distributorSendType}`;
			const res = await get_generated_file_list(folderPath, folderState);
			setGeneratedFileList(res.generatedFileList);
		} catch (error) {
			setGeneratedFileList(null);
			if (error?.response?.status === 404) {
				return openNotificationWithIcon(
					TYPE.ERROR,
					"Directorio vacío",
					"El criterio de búsqueda no posee archivos para mostrar",
				);
			} else {
				return openNotificationWithIcon(
					TYPE.ERROR,
					"Error de búsqueda",
					"Ha ocurrido un error al intentar realizar la búsqueda, por favor contacte con soporte a soporte@onetransfer.com",
				);
			}
		}
	};

	useEffect(() => {
		selectedType &&
			selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS &&
			fetch_distributors();
		selectedType &&
			selectedType === CONSTANTS.FILE_FOLDER_MEGADISTRIBUTORS &&
			fetch_mega_distributors();
	}, [selectedType]);

	useEffect(() => {
		selectedDistributor && fetch_generated_file_list();
	}, [selectedDistributor]);

	const columns = [
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>
					FECHA CREACION
				</div>
			),
			dataIndex: "created",
			key: "created",
			width: 200,
			render: (value, record, index) => {
				return (
					<Typo level={6} type="darkGrey">
						{moment(value).format("DD-MM-YYYY")}
					</Typo>
				);
			},
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>
					NOMBRE ARCHIVO
				</div>
			),
			dataIndex: "name",
			key: "name",
			render: (value, record, index) => {
				const parts = value.split("/");
				const fileName = parts[parts.length - 1];
				return (
					<Typo level={6} type="secondary" fontWeight={700}>
						{fileName}
					</Typo>
				);
			},
		},
		{
			title: () => <div style={{ color: COLORS.White, fontWeight: 700 }}></div>,
			dataIndex: "download",
			key: "download",
			width: 100,
			align: "center",
			render: (text, record, index) => (
				<div
					onClick={(e) => handleDownload(record.name)}
					style={{ cursor: "pointer" }}
				>
					<BsDownload color={COLORS.Primary} />
				</div>
			),
		},
	];

	const handleDownload = async (filePath) => {
		setIsLoading(true);
		try {
			const parts = filePath.split("/");
			const fileName = parts[parts.length - 1];
			const res = await download_file_content(filePath);
			const href = URL.createObjectURL(res);

			const link = document.createElement("a");
			link.href = href;

			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Archivos generados
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>
			<Main.Body>
				<Inner>
					<Section>
						<FilterContainer>
							<Typo type="darkGrey" fontWeight={700} fontSize={30}>
								Archivos Generados
							</Typo>
							<div>
								<Select
									style={{ width: "200px" }}
									onChange={(e) => {
										setSelectedType(e);
										setSelectedDistributor(null);
										setGeneratedFileList(null);
									}}
									placeholder="Elegir tipo"
								>
									<Option key={1} value={CONSTANTS.FILE_FOLDER_DISTRIBUTORS}>
										Droguería
									</Option>
									<Option
										key={2}
										value={CONSTANTS.FILE_FOLDER_MEGADISTRIBUTORS}
									>
										Distribuidor
									</Option>
								</Select>
								{distributors && selectedType && (
									<Select
										style={{ width: "250px", paddingLeft: 10 }}
										onChange={(e) => setSelectedDistributor(e)}
										placeholder={
											selectedType === CONSTANTS.FILE_FOLDER_DISTRIBUTORS
												? "Elegir droguería"
												: "Elegir distribuidor"
										}
										value={selectedDistributor}
									>
										{distributors?.map((i, idx) => (
											<Option key={`distributor_${idx}`} value={i.id}>
												{i.name}
											</Option>
										))}
									</Select>
								)}
							</div>
						</FilterContainer>
						{selectedDistributor && generatedFileList && (
							<TableContainer>
								<AntdTable
									columns={columns}
									loading={isLoading}
									dataSource={generatedFileList}
									pagination={false}
									scroll={{
										y: 500,
									}}
								/>
							</TableContainer>
						)}
					</Section>
				</Inner>
			</Main.Body>
		</Main>
	);
}
